import React, { Component } from "react";
import { leadType } from "../../app";
import FormStep from "../../common/components/formStep";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import AddMoreLoanAmount from "../../common/components/pageBlocks/vehicleDetails/addMoreLoanAmount";
import FinalSubmit from "../../common/components/pageBlocks/vehicleDetails/finalSubmit";
import VehicleInfoForm from "../../common/components/pageBlocks/vehicleDetails/vehicleInfoForm";
import commonContext, { AppContext } from "../../common/context/common";
import { Zd10SecApis } from "../apis/zd10SecApis";

interface IProps {
    history: any;
}
interface IState {}
export default class VehicleDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: Zd10SecApis;
    steps = [
        { title: "Vehicle", active: true },
        { title: "Loan" },
        { title: "Review" },
        { title: "Personal" },
        { title: "Confirmation" },
    ];
    componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Zd10SecApis;
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.apis.updateCarInfo(this.lead);
        if (apiData.error?.error) {
            console.log(apiData.error);
        }
        if (apiData.result) {
            return this.props.history.push("/loan-details");
        }
    };

    render() {
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="vehicle-wrap mt-110">
                        <form onSubmit={(e) => this.handleOnSubmit(e)}>
                            <div className="container mx-auto px-5">
                                <FormStep steps={this.steps} />
                                <VehicleInfoForm />
                            </div>
                            <AddMoreLoanAmount />
                            <FinalSubmit />
                        </form>
                    </section>
                </div>
            </>
        );
    }
}
